import { properCase } from "LIB/formatters/text";

export const AIRCRAFT = "aircraft";
export const APU = "apu";
export const ENGINE = "engine";
export const LANDING_GEAR = "landing_gear";
export const OTHER = "other";

export const AMOUNT_PAID = "amount_paid";
export const COST_SPLIT = "cost_split";
export const COST_SPLIT_LABEL = "Applied Cost Perc. (%)";
export const INVOICE_DATE = "invoice_date";
export const INVOICE_DUE_DATE = "invoice_due_date";
export const INVOICE_NUMBER = "invoice_number";
export const INVOICE_PAID_DATE = "invoice_paid_date";
export const LOT_CODE = "lot_code";
export const LOT_PO_NUMBER = "lot_po_number";
export const LOT_TYPE = "lot_type";
export const LOT_NAME = "lot_name";
export const LOT_PRICE = "lot_price";
export const LOT = "lot";
export const LOT_LINE_ITEM = "lot_line_item";
export const LOT_ID = "lot_id";
export const LOT_LINE_ITEMS = "lot_line_items";
export const MANAGED_REPAIR_ORDER = "mro";
export const ORIGINAL_COST = "original_cost";
export const PORTAL_PURCHASE = "portal_purchase";
export const REFERENCE_NUMBER = "reference_number";
export const SHIP_DATE = "ship_date";
export const AS_IS = "as_is";

export const ATTACHMENT_TYPES = {
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  traceability: {
    label: "Traceability"
  },
  tag_copies: {
    label: "Tag Copies"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  photos: {
    label: "Photos"
  },
  external_link: {
    label: "External Link"
  },
  end_user_agreement: {
    label: "End User Agreement"
  }
};

export const LOT_TYPES = {
  [AIRCRAFT]: {
    label: properCase(AIRCRAFT),
    value: AIRCRAFT
  },
  [APU]: {
    label: APU.toUpperCase(),
    value: APU
  },
  [ENGINE]: {
    label: properCase(ENGINE),
    value: ENGINE
  },
  [LANDING_GEAR]: {
    label: properCase(LANDING_GEAR),
    value: LANDING_GEAR
  },
  [OTHER]: {
    label: properCase(OTHER),
    value: OTHER
  }
};



// WEBPACK FOOTER //
// ./app/modules/Lots/constants.js